import { render, staticRenderFns } from "./CourseCodelyAssignment.vue?vue&type=template&id=19038ad8"
import script from "./CourseCodelyAssignment.vue?vue&type=script&lang=js"
export * from "./CourseCodelyAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports